module.exports = __webpack_public_path__ + "img/86.4f927bde.jpg";